module.exports = __webpack_public_path__ + "5b1edd581548eeba030fe59821dc33cc.png";